import IModuleLazyLoadService from '../interface/core/service/module-lazy-load-service';
// import { Transition } from '@uirouter/angularjs'

export function moduleLoader(load: (_: IModuleLazyLoadService) => ng.IPromise<void>) {
  // TODO: Type error occurs when Transition is used
  // TS2307: Cannot find module '@uirouter/core'.
  return ($transition$: any /*Transition*/) =>
    load($transition$.injector().get('ModuleLazyLoadService'));
}
